PJQ.views.changeRequests.ChangeRequestManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-request-management'),
        subTemplates: {
            changeRequestTotals: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-totals')
        },
        changeRequestId: null,
        rfqId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');
        this.options.canViewRFQs = PJQ.app.session.project.hasPermission('changeRequests.canViewRFQs');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            changeRequests: this.changeRequests,
            rfqs: this.rfqs,
            canViewChangeRequests: this.options.canViewChangeRequests,
            canViewRFQs: this.options.canViewRFQs,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.changeRequestsView = null;
        this.rfqView = null;

        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.changeRequestId > 0 && this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else if (this.options.rfqId > 0 && this.options.canViewRFQs) {
            this.activateTab('rfq');
        } else if (this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else {
            this.activateTab('rfq');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changerequests':
                if (this.changeRequestsView == null || this.changeRequestsView.collection == null || !this.changeRequestsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeRequestsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.changeRequestTotals, $totals, {
                    pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
                });
                break;
            default:
                $totals.empty();
                return;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;
        switch (tab ? tab.toLowerCase() : null) {
            case 'rfq':
                tab = 'RFQ_List';
                this.renderRFQView();
                break;
            default:
                tab = 'CR_List';
                this.renderChangeRequestsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if (this.isActivating) {
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#CR_List':
                vw = 'changerequests';
                this.$('.btn-settings').show();
                break;
            case '#RFQ_List':
                vw = 'rfq';
                this.$('.btn-settings').hide();
                break;
        }
        this.activateTab(vw);
    },
    renderChangeRequestsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/changerequests', {
            trigger: false
        });
        if (this.changeRequestsView == null && this.options.canViewChangeRequests) {
            let fnRender = () => {
                this.changeRequestsView = new PJQ.views.changeRequests.ChangeRequestsList({
                    el: this.$('.change-requests-pane'),
                    project: PJQ.app.session.project,
                    changeRequestId: this.options.changeRequestId,
                    collection: this.changeRequests,
                    hideHeader: true,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeRequestId = null;
            };

            if (this.changeRequests == null) {
                this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeRequests.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderRFQView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/changerequests/rfq', {
            trigger: false
        });
        if (this.rfqView == null) {
            let fnRender = () => {
                this.rfqView = new PJQ.views.rfq.RFQList({
                    el: this.$('.rfq-pane'),
                    project: PJQ.app.session.project,
                    rfqId: this.options.rfqId,
                    collection: this.rfqs,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.rfqId = null;
            };

            if (this.rfqs == null) {
                this.rfqs = new PJQ.collections.rfq.RFQs(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.rfqs.fetch({
                    success: () => {
                        fnRender();
                    }
                });
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#CR_List':
                if (this.changeRequestsView != null) {
                    this.changeRequestsView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $changeRequestsSpan = this.$('.commitments-total'),
            $rfqSpan = this.$('.rfq-total');

        $changeRequestsSpan.text(_.size(this.changeRequests.models));
        $rfqSpan.text(_.size(this.rfq.models));
    }
});